<template>
  <div class="infor fl">
    <AllHeader
      label="申报项目"
      ischage="ischage"
      sublabel="返回记录列表"
      subtitle="建筑与市政工程绿色施工评价"
      @getvalue="getvalue"
    />
    <div>
      <Lineconbgtir
        :labelcontainer="labelcontaineragain"
        style="margin-top: 20px"
      />
      <p
        style="
          font-size: 14px;
          color: #9fa5ae;
          margin: 10px 0 0;
          text-align: start;
        "
      >
        项目名称：{{$route.query.name}}
      </p>
      <div class="upload">
        <el-upload
          class="upload-demo"
          :action="'/api/home/upload/file/award_log'"
          :on-preview="handlePreview"
          :data="{ token: token }"
          accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-success="handleAdd"
          :on-error="handleError"
          list-type="text"
          :limit="1"
        >
          <div class="uploadheader">
            <span>1、建筑与市政工程绿色施工验收评价申请表</span>
            <el-button
              size="small"
              icon="el-icon-upload2"
              style="color: #194abe"
              >点击选择文件</el-button
            >
            <span
              v-if="showErr"
              class="el-upload__tip margin-left-30"
              slot="tip"
            >
              <i class="el-icon-error"></i
              >支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
            </span>
          </div>
        </el-upload>
      </div>
      <div class="upload">
        <el-upload
          class="upload-demo"
          :action="'/api/home/upload/file/award_log'"
          :data="{ token: token }"
          accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
          :on-remove="handleRemove2"
          :file-list="fileList2"
          :on-success="handleAdd2"
          :on-error="handleError"
          list-type="text"
          :limit="1"
        >
          <div class="uploadheader">
            <span>2、建筑与市政工程绿色施工评价申报单位承诺书</span>
            <el-button
              size="small"
              icon="el-icon-upload2"
              style="color: #194abe"
              >点击选择文件</el-button
            >
            <span
              v-if="showErr"
              class="el-upload__tip margin-left-30"
              slot="tip"
            >
              <i class="el-icon-error"></i
              >支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
            </span>
          </div>
        </el-upload>
      </div>
      <div class="flex-left">
        <el-button
          size="small"
          icon="el-icon-check"
          style="background-color: #194abe; color: white; margin-bottom: 20px"
          class="block-submit"
          @click="onSubmitTap"
          >提交平台审核</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import AllHeader from "@/components/Modal/AllHeader";
import Lineconbgtir from "./Modal/Line";
import { submitFile } from "../utils/api.js";
export default {
  components: {
    AllHeader,
    Lineconbgtir
  },
  data() {
    return {
      sublabel: "返回记录列表",
      subtitle: "",
      ischage: "",
      lable: "",
      token: "",
      fileList: [],
      file_urls: [],
      fileList2: [],
      showErr: false,
      labelcontaineragain: {
        lable: "上传附件",
        desc: "Upload the completed form",
      },
    };
  },
  mounted() {
    this.token = "Bearer " + localStorage.getItem("TOKEN");
  },
  methods: {
    onSubmitTap() {
      if (this.file_urls[0]==null||this.file_urls[1]==null) {
        this.$message({
            type: "warning",
            message: '请上传必备文件',
          });
        return false
      }
      const data = {
        file_urls: this.file_urls,
      };
      submitFile(data, this.$route.query.id).then((res) => {
        console.log(res);
        if (res) {
          this.$message({
            type: "success",
            message: '提交审核成功',
          });
          this.step = 2;
          this.isFail = false;
          if (this.$route.query.baid) {
            const baid = this.$route.query.baid;
            const btitle = this.$route.query.btitle || '';
            this.$router.push('/member/Declar_record?baid=' + baid + '&btitle=' + btitle)
          } else {
            this.$router.go(-1)
          }
        }else{
            this.$message({
            type: "error",
            message: '提交审核失败',
          });
        }
      });
    },
    getvalue() {
      this.$router.go(-1)
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleAdd(response, file, fileList) {
      this.fileList[0] = {
        name:fileList[0].response.data.originalName,
        url:fileList[0].response.data.host + fileList[0].response.data.url
      }
     this.file_urls[0] = this.fileList[0].url
    },
    handleAdd2(response, file, fileList) {
      this.fileList2[0] = {
        name:fileList[0].response.data.originalName,
        url:fileList[0].response.data.host + fileList[0].response.data.url
      }
     this.file_urls[1] = this.fileList2[0].url
    },
    handleError(err, file, fileList) {
      this.showErr = true;
      let that = this;
      setTimeout(function () {
        that.showErr = false;
      }, 2000);
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.fileList = []
      this.file_urls[0] = null
    },
    handleRemove2(file, fileList) {
      // console.log(file, fileList);
      this.fileList2 = []
      this.file_urls[1] = null
    },
  },
};
</script>

<style lang="less" scoped>
.applybut {
  padding: 6px 15px;
}
/deep/.block-title {
  border-left: 3px solid #194abe !important;
}
/deep/.el-upload-list {
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  text-align: start;
  height: auto;
}

.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
    position: relative;
    &-r-t {
      position: absolute;
      top: 0;
      right: 0;
      width: 73px;
      height: 27px;
      background: #f5f9fb;
      opacity: 1;
      border-radius: 0px 0px 0px 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #c6c9ce;
      padding-left: 10px;
      box-sizing: border-box;
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
</style>
